import { render } from "./SiteFooter.vue?vue&type=template&id=f8e05d96&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=f8e05d96&lang=scss&scoped=true"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-57de6a73e2/0/cache/vue-loader-npm-17.4.2-00674d01e5-88760fe6a5.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e05d96"]])

export default __exports__